module.exports = __webpack_public_path__ + "media/images/isignos_logo-ef6d88512dc5f1a890f1ab6626a6e8b4.png";